// This contains common JS used across all modules.
import { getOptimizelyClient } from 'lib/optimizely';
import FormSwiftAPI from './formswift-api';

require('site-header');
require('track-usage');
require('ui-tools');
require('../../sass/main.scss');

window.getOptimizelyClient = getOptimizelyClient;
window.FormSwiftAPI = new FormSwiftAPI(window.API_URL);
window.SessionManager = require('session-manager');



// WEBPACK FOOTER //
// ./src-assets/js/common.js